import React, {useEffect, useState} from 'react';
import {Flex, Form, Input, message, Modal, Select, Upload} from "antd";
import IntlMessage, {IntlMessageText} from "../../../../../components/IntlMessage/IntlMessage";
import classes from "../../Applications/application.module.css";
import FormItem from "antd/es/form/FormItem";
import {useTranslation} from "react-i18next";
import MicroQualificationService from "../../../../../services/MicroQualificationService";
import {useDispatch, useSelector} from "react-redux";
import MyText from "../../../../../components/UI/Text/MyText";
import {LocalName} from "../../../../../utils/LocalName";
import {changeCurrentPage} from "../../../../../store/slices/tableController/GroupEpListTableController";
import BlackerBlueButton from "../../../../../components/UI/Buttons/BlackerBlueButton";
import MyTable from "../../../../../components/Table/MyTable";
import {getAllGroupEps} from "../../../../../store/slices/GroupEpsSlice";
import GreenButton from "../../../../../components/UI/Buttons/GreenButton";
import BhargaButton from "../../../../../components/UI/Buttons/BhargaButton";
import {UploadOutlined} from "@ant-design/icons";

const GroupEpPage = () => {
    const [form] = Form.useForm();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const {groupEPs, isLoading, hasMore, error} = useSelector(state => state.groupEPList)
    const {currentPage, pageSize} = useSelector(state => state.groupEpListTableController);

    const nameRu = Form.useWatch('nameRu', form);
    const nameKz = Form.useWatch('nameKz', form);
    const nameEng = Form.useWatch('nameEng', form);
    const code = Form.useWatch('code', form);
    const trainingDirection = Form.useWatch('trainingDirection', form);

    const [isLoadingCreate, setIsLoadingCreate] = useState(false);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [openModal, setOpenModal] = useState(false)
    const [educationFields, setEducationFields] = useState([])
    const [trainingDirections, setTrainingDirections] = useState([])

    const [uploadedFile, setUploadedFile] = useState(null);

    const columns = [
        {
            title: <MyText center strong><IntlMessage id={"educationField"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record?.trainingDirection?.educationField)}</MyText>
            ),
            width: '10%',
        },
        {
            title: <MyText center strong><IntlMessage id={"trainingDirection"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record?.trainingDirection)}</MyText>
            ),
            width: '10%',
        },
        {
            title: <MyText center strong><IntlMessage id={"nameRu"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record.nameRu}</MyText>
            ),
            width: '20%',
        },
        {
            title: <MyText center strong><IntlMessage id={"nameKz"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record.nameKz}</MyText>
            ),
            width: '20%',
        },
        {
            title: <MyText center strong><IntlMessage id={"nameEng"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record.nameEng}</MyText>
            ),
            width: '20%',
        },
        {
            title: <MyText center strong><IntlMessage id={"certificate.code"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record.code}</MyText>
            ),
            width: '20%',
        },

    ];

    function handleCreate() {
        form.validateFields()
            .then(async (values) => {
                setIsLoadingCreate(true);
                setOpenModal(false)
                await MicroQualificationService.saveEducationProgramsGroup(nameRu, nameKz, nameEng, code, trainingDirection)
                    .then(() => {
                        message.success(<IntlMessage id={'success'}/>)
                        form.resetFields();
                    })
                    .catch(() => {
                        message.error(<IntlMessage id={'error'}/>)
                    })
                    .finally()
            })
            .catch((error) => {
                console.log("Validation error!", error);
            })
            .finally(() => {
                dispatch(getAllGroupEps({
                    page: currentPage,
                    limit: pageSize
                }))
                setIsLoadingCreate(false);
                message.destroy();
            });
    }

    async function getEducationFields() {
        if (educationFields.length === 0) {
            setIsLoadingData(true);
            await MicroQualificationService.getEducationFields(1, 100)
                .then((r) => {
                    setEducationFields(r.data.map(field => {
                        return {
                            value: field.id,
                            label: LocalName.getName(field)
                        }
                    }));
                })
                .catch(() => {
                    message.destroy();
                    message.error(<IntlMessage id={'error'}/>, 5);
                })
                .finally(() => {
                    setIsLoadingData(false);
                })
        }
    }

    async function getTrainingDirections() {
        if (trainingDirections.length === 0) {
            setIsLoadingData(true);
            await MicroQualificationService.getTrainingDirections(1, 100)
                .then((r) => {
                    setTrainingDirections(r.data.map(field => {
                        return {
                            value: field.id,
                            label: LocalName.getName(field)
                        }
                    }));
                })
                .catch(() => {
                    message.destroy();
                    message.error(<IntlMessage id={'error'}/>, 5);
                })
                .finally(() => {
                    setIsLoadingData(false);
                })
        }
    }

    useEffect(() => {
        dispatch(getAllGroupEps({
            page: currentPage,
            limit: pageSize
        }));
    }, []);

    const fetchData = async (params) => {
        return dispatch(getAllGroupEps({
            ...params
        }));
    }

    const saveCurrentPageSettings = (page, pageSize) => {
        dispatch(changeCurrentPage({page: page, pageSize: pageSize}));
    };

    const handleChangeExcel = (info) => {
        setUploadedFile(info.file);
    };

    const propsExcelFile = {
        beforeUpload: () => false,
        onChange: handleChangeExcel,
        multiple: false,
    };

    const handleImportExcelFile = async () => {
        setIsLoadingCreate(true);
        await MicroQualificationService.importEducationGroupProgramsByExcel(uploadedFile)
            .then(() => {
                message.success(<IntlMessage id={'success'}/>)
                setUploadedFile(null);
            })
            .catch()
            .finally(() => {
                dispatch(getAllGroupEps({
                    page: currentPage,
                    limit: pageSize
                }))
                setIsLoadingCreate(false);
                message.destroy();
            })
    }

    return (
        <Flex style={{width: "100%"}} gap={20} align={"flex-start"} justify={"flex-start"} vertical>
            <MyText uppercase strong size={"large"}><IntlMessage id={'groupEP'}/></MyText>
            <Flex gap={"large"} justify={"center"} align={"center"}>
                <BlackerBlueButton onClick={() => {
                    setOpenModal(true)
                    getEducationFields();
                }}>
                    <IntlMessage id={'create'}/>
                </BlackerBlueButton>
                <Upload {...propsExcelFile} fileList={uploadedFile ? [uploadedFile] : []}>
                    <GreenButton>
                        <IntlMessage id={'certificate.excelFormat'}/>
                    </GreenButton>
                </Upload>
                {
                    uploadedFile &&
                    <BhargaButton icon={<UploadOutlined/>} onClick={handleImportExcelFile}><IntlMessage id={'upload'}/></BhargaButton>
                }
            </Flex>
            <MyTable
                isLoading={isLoading || isLoadingCreate}
                dataSource={groupEPs}
                columns={columns}
                fetchData={fetchData}
                saveCurrentPage={saveCurrentPageSettings}
                initialPage={currentPage}
                initialPageSize={pageSize}
                hasMore={hasMore}
            />
            <Form form={form} className={classes.form} initialValues={{method: 'group'}}>
                <Modal
                    width={500}
                    maskClosable={true}
                    title={<IntlMessage id={'groupEP'}/>}
                    open={openModal}
                    onOk={handleCreate}
                    onCancel={() => {
                        setOpenModal(false)
                    }}
                    loading={isLoadingData}
                    okText={<IntlMessage id={'create'}/>}
                    cancelText={<IntlMessage id={'close'}/>}
                >
                    <Flex vertical style={{width: '100%'}} gap={4}>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('educationField')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}}
                                  name="educationField">
                            <Select options={educationFields}
                                    placeholder={IntlMessageText.getText({id: "educationField"})}
                                    onSelect={(e) => getTrainingDirections(e)}/>
                        </FormItem>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('trainingDirection')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}}
                                  name="trainingDirection">
                            <Select options={trainingDirections}
                                    placeholder={IntlMessageText.getText({id: "trainingDirection"})}/>
                        </FormItem>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('nameRu')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}} name="nameRu">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: "nameRu"})}/>
                        </FormItem>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('nameKz')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}} name="nameKz">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: "nameKz"})}/>
                        </FormItem>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('nameEng')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}} name="nameEng">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: "nameEng"})}/>
                        </FormItem>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  name="code"
                                  label={<IntlMessage id="certificate.code"/>}
                                  labelCol={{span: 24}}
                                  className={classes.formInput}
                                  style={{width: '100%', padding: 0}}
                        >
                            <Input placeholder={t("certificate.code")}/>
                        </FormItem>
                    </Flex>
                </Modal>
            </Form>
        </Flex>
    );
};

export default GroupEpPage;